import * as actionTypes from '../Register_action.types';

const initialState = {
  loggingIn: false,
  panIndiaFoms: [],
  error: null,
  message: '',
};

const fetchPanIndiaReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.PAN_INDIA_FORM_GET_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case actionTypes.PAN_INDIA_FORM_GET_SUCCESS:
      return {
        ...state,
        loading: false,
        panIndiaFoms: action.payload,
      }

    case actionTypes.PAN_INDIA_FORM_GET_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };

    default:
      return state;
  }
};

export default fetchPanIndiaReducer
